import React, { useContext, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { useNavigate } from 'react-router-dom'
import { Content, Layout, Navigation, Responsive, Card } from 'ui'
import { userUrlForUser } from './helpers'
import { usePaginatedRoles } from './usePaginatedRoles'
import { UserForm, UserFormSuccessFn } from './UserForm'
import { PromoteExistingUserForm } from './PromoteExistingUserForm'
import { AdminRoleNavigationDrawer } from './AdminRoleNavigationDrawer'

type TabType = 'create' | 'promote'

export const AdminRoleCreateView: React.FC = () => {
  const navigate = useNavigate()
  const [activeTab, setActiveTab] = useState<TabType>('create')

  // Drawer appearance
  const { useDisplayMode } = useContext(Responsive.DrawerManagerContext)
  useDisplayMode('compact')

  const { search } = usePaginatedRoles()

  const handleSuccess: UserFormSuccessFn = (userId) => {
    navigate(`${userUrlForUser({ id: userId } as any)}${search}`)
  }

  return (
    <div className="w-full flex-grow flex-col flex sm:flex-row flex">
      <Helmet title={`Create User - MCSS Pro Connect`} />
      <AdminRoleNavigationDrawer />
      <Layout.PaddedContent>
        <Content.Body>
          <Navigation.ReturnLink to={`/admin/roles${search}`}>
            Return to Users
          </Navigation.ReturnLink>
        </Content.Body>
        <Content.Heading>Add Admin User</Content.Heading>

        {/* Tab Navigation */}
        <div className="flex border-b border-gray-300 mb-6">
          <button
            className={`px-4 py-2 font-medium ${
              activeTab === 'create'
                ? 'border-b-2 border-blue-500 text-blue-600'
                : 'text-gray-500 hover:text-gray-700'
            }`}
            onClick={() => setActiveTab('create')}
          >
            Create New Admin
          </button>
          <button
            className={`px-4 py-2 font-medium ${
              activeTab === 'promote'
                ? 'border-b-2 border-blue-500 text-blue-600'
                : 'text-gray-500 hover:text-gray-700'
            }`}
            onClick={() => setActiveTab('promote')}
          >
            Promote Existing User
          </button>
        </div>

        {/* Tab Content */}
        <Card.View className="p-6">
          {activeTab === 'create' ? (
            <UserForm loading={false} onSuccess={handleSuccess} />
          ) : (
            <PromoteExistingUserForm />
          )}
        </Card.View>
      </Layout.PaddedContent>
    </div>
  )
}
